import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 10"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 9.212c-.323 0-.627-.126-.856-.354l-6.79-6.79A1.2 1.2 0 0 1 0 1.213 1.21 1.21 0 0 1 1.21 0c.325 0 .63.126.858.356L8 6.286l5.931-5.93A1.2 1.2 0 0 1 14.79 0a1.213 1.213 0 0 1 .857 2.067l-6.789 6.79a1.2 1.2 0 0 1-.856.355"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }